module.exports = __webpack_public_path__ + "img/company_logo4.fc3ac27c.jpg";